/*
 * @Date: 2019-08-20 18:24:17
 * @LastEditors: x
 * @LastEditTime: 2023-06-02 13:57:35
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const resolveViews = path => resolve => require(['views/' + path], resolve)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: 'index'
    },
    {
      name: 'index',
      path: '/index',
      component: resolveViews('index')
    },
    {
      name: 'login',
      path: '/login',
      component: resolveViews('login')
    },
    {
      name: 'register',
      path: '/register',
      component: resolveViews('register')
    },
    {
      name: 'register2',
      path: '/register2',
      component: resolveViews('register2')
    },
    {
      name: 'retrievePwd',
      path: '/retrievePwd',
      component: resolveViews('retrievePwd')
    },
    {
      name: 'pay',
      path: '/pay',
      component: resolveViews('pay')
    },
    {
      name: 'ticket',
      path: '/ticket',
      component: resolveViews('ticket')
    },
    {
      name: 'ticketDetail',
      path: '/ticketDetail',
      component: resolveViews('ticket-detail')
    },
    {
      name: 'routeRedirect',
      path: '/routeRedirect',
      component: resolveViews('routeRedirect')
    },
    {
      name: 'certificate',
      path: '/certificate',
      component: resolveViews('certificate')
    },
  ],
  mode: 'history',
  linkActiveClass: 'active'
})
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)  
  next()
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js